module.exports = __webpack_public_path__ + "img/c02_unitelephantarcherchampion_Normal_ua.b4dda6f5.webp";